// viewModels/QRScreenViewModel.ts
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import QRCode from 'qrcode';
import { apiConfig, APIIntegration } from '@integrations/APIIntegration';
import designSystem from '@styles/designSystem';
import { Analytics } from '@core/Analytics/Analytics';
import { Application } from '@core/Application';

interface LocationData {
    qpID: string;
    locationName: string;
    address: string;
    coordinates: {
        latitude: number;
        longitude: number;
    };
}

interface UserData {
    name: string;
    phone: string;
    company: string;
}

export const useQRScreenViewModel = (qpID?: string) => {
    const location = useLocation();
    const navigate = useNavigate();
    
    const [qrCodeUrl, setQrCodeUrl] = useState<string>('');
    const [isLoading, setIsLoading] = useState(false);
    
    // Get data from previous screens
    const locationData = location.state as LocationData & UserData;
    const qpId = locationData?.qpID ?? qpID
    const analytics = new AnalyticsHelper()

    const viewDidAppear = () => {
        analytics.trackScreenShown()
    }
    
    useEffect(() => {
        if (qpId) {
            generateQRCode();
        } else {
            console.error('No qpID found in location state');
        }
    }, [qpId]);

    const generateQRCode = async () => {
        setIsLoading(true);
        
        try {
            // Create WhatsApp link with message using the qpID from state
    
            const message = 'Hola quiero probar fichar en ##%s##!'.localized(qpId);
            const encodedMessage = encodeURIComponent(message);
            const whatsappUrl = apiConfig.waQRbaseUrl+`?text=${encodedMessage}`;
            
            // Generate QR code
            const qrDataUrl = await QRCode.toDataURL(whatsappUrl, {
                width: 400,
                margin: 2,
                color: {
                    dark: '#0F0F0F',
                    light: '#FFFFFF',
                },
            });
            
            setQrCodeUrl(qrDataUrl);
            
        } catch (error) {
            console.error('Error generating QR code:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleContinue = () => {
        // Navigate to next screen
        
        navigate('/checkins', {
            state: locationData
        });
    };

    const handleAlreadyDone = () => {
        // User already scanned the QR
        handleContinue();
    };

    return {
        qrCodeUrl,
        qpId,
        isLoading,
        locationData,
        handleContinue,
        handleAlreadyDone,
        viewDidAppear,
    };
};

class AnalyticsHelper {
    private analytics: Analytics
    constructor(analytics: Analytics = Application.shared().coreDependencies.analytics) {
        this.analytics = analytics
    }

    async trackScreenShown() {
        this.analytics.track({
            eventType: 'AutoDemo.QRScreen.Shown',
        })
    }

    async trackFormCompleted() {
        this.analytics.track({
            eventType: 'AutoDemo.QRScreen.formCompleted',
        })
    }
}